import { useEffect, useState } from 'react';
import { SET_STEP, SET_TOTAL_STEPS } from '../../events';

function useStepperValues({
  initialTotalSteps = 1,
  initialStep = 0,
}: { initialStep?: number; initialTotalSteps?: number } = {}) {
  const [step, setStep] = useState(initialStep);
  const [totalSteps, setTotalSteps] = useState(initialTotalSteps);

  useEffect(() => {
    const onSetStep = (event: CustomEvent) => {
      const { detail } = event;
      setStep(detail);
    };

    const onSetTotalSteps = (event: CustomEvent) => {
      const { detail } = event;
      setTotalSteps(detail);
    };

    window.addEventListener(SET_STEP, onSetStep);
    window.addEventListener(SET_TOTAL_STEPS, onSetTotalSteps);
    return () => {
      window.removeEventListener(SET_STEP, onSetStep);
      window.removeEventListener(SET_TOTAL_STEPS, onSetTotalSteps);
    };
  }, []);

  // Update the state if the initial values change
  useEffect(() => setStep(initialStep), [initialStep]);
  useEffect(() => setTotalSteps(initialTotalSteps), [initialTotalSteps]);

  return { step, totalSteps };
}

export default useStepperValues;
